import { Alert, Box, Button, Typography } from "@mui/material";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router-dom";

export default function PasswordResetComplete(props) {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: 500,
        margin: "0 auto",
      }}
    >
      <Container
        maxWidth="sm"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",

          padding: "0px",
          width: "552px",
          maxWidth: "90vw",
          height: "320px",
          backgroundColor: "common.white.main",
        }}
      >
        <Typography
          variant="h5"
          sx={{ mb: 3, textAlign: "center", width: "100%" }}
        >
          パスワード更新完了
        </Typography>
        <Alert severity="success" sx={{ mb: 3, width: "100%" }}>
          パスワードを更新しました。
        </Alert>

        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            navigate("/login");
          }}
          sx={{ mt: 2 }}
        >
          ログイン画面に戻る
        </Button>
      </Container>
    </Box>
  );
}
